import { parse } from "util/parsers";
import type { Setup } from "features/setups/types";
import { BaseSetupValue, type JsonAssocValue, type ISetupValue } from "../types";

export class JsonAssocSetupValue extends BaseSetupValue<JsonAssocValue> implements ISetupValue<JsonAssocValue> {
    public deserialize(setupValue: Setup<string>['setupValue']): JsonAssocValue {
       return parse(setupValue, null);
    }

    public serialize() {
        return JSON.stringify(this.value);
    }
}
